import { ITableFilter, IFilterTable } from "../filter.objects";
import _ from "lodash";
import { getMonthYearDisplay } from "../../../scripts/date-functions";
export class MonthYearFilter implements ITableFilter {
    filterId: string; 
    displayName: string; 
    monthPropertyName: string;
    yearPropertyName: string;

    filterOptions: MonthYearFilterOptions;
    filterTable: IFilterTable;

    constructor(filterId: string, displayName: string, monthPropertyName: string, yearPropertyName: string, options: MonthYearFilterOptions = new MonthYearFilterOptions()) {
        this.filterId = filterId;
        this.displayName = displayName;
        this.monthPropertyName = monthPropertyName;
        this.yearPropertyName = yearPropertyName;
        this.filterOptions = options;
    }

    initialize(items: any[], filterTable: IFilterTable) {
        this.filterTable = filterTable;
        this.initializeDropdown(items);
        this.initializeFilter();
    }

    generateFilterHtml(): string {
        let liveSearch = "";
        if (this.filterOptions.liveSearch) {
            liveSearch = `data-live-search="true"`;
        }

        let html = `
            <div id="${this.filterId}-select" class="col-12 ${this.filterOptions.className}">
                <div id="${this.filterId}-block" class="filter-label d-inline-block label-only">${this.displayName}</div>
                <select id="${this.filterId}-dropdown" class="selectpicker dropdown" title="None Selected" data-actions-box="true" data-width="100%" data-container="body" data-size="10"  ${liveSearch} multiple>
                </select>
            </div>
        `;

        return html;
    }

    private initializeDropdown(items: any[]): void {
        let selectId = `#${this.filterId}-dropdown`;

        let optionValArr: string[] = items.map(item => this.getMonthYearValue(item));
        let uniqueOptions = _.uniq(optionValArr);
        uniqueOptions = uniqueOptions.map(option => {
            if (!option) {
                return "--None--";
            }
            return option;
        });
        uniqueOptions.sort((x1: string, x2: string) => {
            if (x1.startsWith("-") && !x2.startsWith("-")) {
                return 1;
            }
            else if (x2.startsWith("-") && !x1.startsWith("-")) {
                return -1;
            }
            else {
                return x1.localeCompare(x2);
            }
        });
        $(selectId).selectpicker({
            dropupAuto: false,
            selectedTextFormat: "count",

            countSelectedText: (numSelected, numTotal) => {
                if (numSelected == numTotal) {
                    return "All";
                }
                else {
                    return numSelected + " Selected";
                }
            }
        });

        uniqueOptions.forEach(option => {
            $(selectId).append(new Option(this.getMonthYearDisplayFromVal(option), option, false, this.filterOptions.defaultAllSelected));
        })

        $(selectId).selectpicker("refresh");
        
    }

    private initializeFilter() {
        let selectId = `#${this.filterId}-dropdown`;
        $(selectId).on('changed.bs.select', (e, clickedIndex, isSelected, previousValue) => {
            this.filterTable.triggerFilter();
        });
    }

    filterItems(items: any[]): any[] {
        let selectId = `#${this.filterId}-dropdown`;
        let selectedItems = <string[]>$(selectId).val();

        if (!this.filterOptions.defaultAllSelected) {
            // If nothing is selected, no filtering
            if (selectedItems.length == 0) {
                return items;
            }
        }

        selectedItems = selectedItems.map(item => {
            if (item == "--None--") {
                return "";
            }
            else {
                return item;
            }
        })
        let filteredItems = items.filter(item => selectedItems.includes(this.getMonthYearValue(item)));
        return filteredItems;
        
    }

    private getMonthYearDisplayFromVal(itemVal: string): string {
        let dateArr = itemVal.split("-");
        if (dateArr.length !== 2) {
            return "";
        }

        let monthVal = parseInt(dateArr[1]);
        let yearVal = parseInt(dateArr[0]);

        if (monthVal == undefined || yearVal == undefined) {
            return "";
        }

        return getMonthYearDisplay(monthVal, yearVal);
    }

    private getMonthYearValue(item: any): string {
        let monthVal = <number>_.get(item, this.monthPropertyName);
        let yearVal = <number>_.get(item, this.yearPropertyName);

        if (monthVal == undefined || yearVal == undefined) {
            return "";
        }

        return `${yearVal}-${monthVal}`;
    }

    getSelected(): string | string[] | number {
        let selectId = `#${this.filterId}-dropdown`;
        let selectedValues = <string[]>$(selectId).val();
        let totalOptionsCount = $(selectId).find("option").length;
        if (totalOptionsCount == selectedValues.length) {
            selectedValues = ["All"];
        }
        return selectedValues;
    }

    setSelected(selectedValues: string | string[] | number): void {
        let selectId = `#${this.filterId}-dropdown`;
        let selectedValuesCount = (<string[]>selectedValues).length;
        if (selectedValuesCount == 1) {
            if (selectedValues[0] == "All") {
                $(selectId).selectpicker("selectAll").trigger("change");
            }
            else {
                $(selectId).val(selectedValues);
                $(selectId).selectpicker("refresh").trigger("change");
            }
        }
        else {
            $(selectId).val(selectedValues);
            $(selectId).selectpicker("refresh").trigger("change");
        }
    }

    resetFilter(): void {
        let selectId = `#${this.filterId}-dropdown`;
        if (this.filterOptions.defaultAllSelected) {
            $(selectId).selectpicker("selectAll");
        }
        else {
            $(selectId).selectpicker("deselectAll");
        }
    }
}

export class MonthYearFilterOptions {    
    liveSearch: boolean = false; // Should filter include live search
    defaultAllSelected: boolean = false; // Should all items be selected by default (if false, nothing selected is equivalent to all selected)
    className: string = "col-md-3 mb-2"; // ClassNames to include on the filter (used for sizing the filter or styling)

    constructor(liveSearch: boolean = false, defaultAllSelected: boolean = true, className: string = "col-md-3 mb-2") {
        this.liveSearch = liveSearch;
        this.defaultAllSelected = defaultAllSelected;
        this.className = className;
    }
}